<template>
  <div class="ShipNameEssentials flex-jc-bt">
    <div class="flex-50 left-side">
      <SpCard custom-class="sp-color-bg-4">
        <div class="flex-al-center flex-jc-end item">
          <span class="flex-75 label">{{ $l('IMONo') }}</span><SpInput v-model="shipInfo.imoNo" :validate-reg="/^(\d{7})?$/" name="imoNo" class="flex-25" type="warn" :width="1" />
        </div>
        <div class="flex-al-center flex-jc-end item">
          <span class="flex-18 label">{{ $l('FirstTitle') }}</span>
          <div class="flex-42">
            <div style="width: 50%">
              <SpSelect v-model="shipInfo.title" name="title" type="warn">
                <SpSelectOption value="MV" label="MV" />
                <SpSelectOption value="MT" label="MT" />
              </SpSelect>
            </div>
          </div>
          <span class="flex-15 label">{{ $l('CallSign') }}</span>
          <SpInput v-model="shipInfo.callSign" :validate-reg="/^([A-Za-z0-9]{4,7})?$/" name="callSign" class="flex-25" type="warn" :width="1" />
        </div>
        <div class="flex-al-center flex-jc-end item">
          <span v-required class="flex-18 label-bold">{{ $l('ShipName') }}</span><SpInput v-model="shipInfo.name" :validate-reg="/^(?=.[a-zA-Z])[A-Za-z0-9-.’ ]{3,64}$/" required name="name" class="flex-42" type="warn" :width="1" />
          <span v-required class="flex-15 label-bold">{{ $l('Flag') }}</span>
          <SpSelect v-model="shipInfo.flag" required name="flag" class="flex-25" type="warn" :width="1">
            <SpSelectOption v-for="item in countrys" :key="item.id" :label="item.name" :value="item.name" />
          </SpSelect>
        </div>
        <div class="flex-al-center flex-jc-end item">
          <span class="flex-18 label">{{ $l('ExName') }}</span><SpInput v-model="shipInfo.exNames" name="exNames" class="flex-82" type="warn" :width="1" />
        </div>
        <div class="flex-al-center flex-jc-end item">
          <span class="flex-75 label">{{ $l('Keellayingtime') }}</span>
          <SpDatePicker v-model="shipInfo.keelLayingDate" name="keelLayingDate" class="flex-25" width="1" type="warn" placeholder=" " />
        </div>
        <div class="flex-al-center flex-jc-end item">
          <span v-required class="flex-25 label-bold">{{ $l('BuiltYear') }}</span><SpInput v-model="shipInfo.builtYear" required name="builtYear" class="flex-25" type="warn" :width="1" />
          <span class="flex-25 label">{{ $l('LaunchDate') }}</span>
          <SpDatePicker v-model="shipInfo.launchDate" name="launchDate" class="flex-25" width="1" type="warn" placeholder=" " />
        </div>
        <div class="flex-al-center flex-jc-end item">
          <span class="flex-75 label">{{ $l('Delivery') }}</span>
          <SpDatePicker v-model="shipInfo.deliveryDate" name="deliveryDate" class="flex-25" width="1" type="warn" placeholder=" " />
        </div>
        <div class="flex-al-center flex-jc-end item">
          <span class="flex-18 label">{{ $l('BuiltinCountry') }}</span>
          <div class="flex-82">
            <div style="width: 40%;">
              <SpSelect v-model="shipInfo.builtInCountry" type="warn">
                <SpSelectOption v-for="item in countrys" :key="item.id" :label="item.name" :value="item.id" />
              </SpSelect>
            </div>
          </div>
        </div>
        <div class="flex-al-center flex-jc-end item">
          <span class="flex-18 label">{{ $l('BuilderShipyard') }}</span>
          <div class="flex-82">
            <SpSelect v-model="shipInfo.shipyard" type="warn" :width="1">
              <SpSelectOption v-for="(item, key) in shipyardOptions" :key="key" :label="item" :value="item" />
            </SpSelect>
          </div>
        </div>
        <div class="border-box flex-al-center flex-jc-end item">
          <span v-required class="flex-18 label-bold">{{ $l('DWTSummer') }}</span>
          <SpInput v-model="shipInfo.dwt" name="dwt" :max="1000000" :min="1000" text-type="number" required class="flex-12" type="warn" :width="1" />
          <span class="flex-4 unit">{{ $l('MT') }}</span>

          <span v-required class="flex-30 label-bold">{{ $l('LadenDraughtDraftSSW') }}</span>
          <SpInput v-model="shipInfo.ladenDraught" :max="30" :min="shipInfo.lightDraught || 4" :precision="2" text-type="number" name="ladenDraught" required class="flex-10" type="warn" :width="1" />
          <span class="flex-3 unit">{{ $l('M') }}</span>

          <span v-required required class="flex-8 label-bold">{{ $l('TPC') }}</span>
          <SpInput v-model="shipInfo.tpc" name="tpc" :max="200" :min="5" :precision="1" text-type="number" required class="flex-5" type="warn" :width="1" />
          <span class="flex-10 unit">{{ $l('MTCM') }}</span>
        </div>
        <div class="flex-al-center flex-jc-end item">
          <span class="flex-64 label">{{ $l('LightDraughtDraftSSW') }}</span>
          <SpInput v-model="shipInfo.lightDraught" :max="30" :min="4" text-type="number" :precision="2" name="lightDraught" class="flex-10" type="warn" :width="1" />
          <span class="flex-5 unit">{{ $l('M') }}</span>
          <span class="flex-21 unit" />
        </div>
      </SpCard>
      <p class="reminder">{{ $l('Reminder') }}</p>
    </div>
    <div class="flex-48 mg-t-40 right-side sp-color-bg-4">
      <div class="text-left">{{ $l('PreferredFormatofParticulars') }}</div>
      <SpInput v-model="shipInfo.particular.content"
               :validate-reg="/^((?=.[a-zA-Z])(.|\s){32,65535})?$/"
               class="mg-t-20" type="warn2" text-type="textArea" :row="50" />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import SpCard from '@/components/common/SpCard'
import SpInput from '@/components/common/SpInput'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import SpDatePicker from '@/components/common/SpDatePicker'
import { getCountrySpareList } from '@/request/APIs/common'
import { getShipyardApi } from '@/request/APIs/so'
export default {
  name: 'ShipNameEssentials',

  nameSpace: 'shipOwner.tonnages.newTonnage.ShipNameEssentials',

  components: {
    SpDatePicker,
    SpSelectOption,
    SpCard,
    SpInput,
    SpSelect
  },

  props: {
    modelValue: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },

  emits: ['update:modelValue'],

  data () {
    return {
      countrys: [],
      shipyardOptions: []
    }
  },

  computed: {
    shipInfo: {
      get () {
        return this.modelValue
      },

      set (nv) {
        this.$emit('update:modelValue', nv)
      }
    }
  },

  created () {
    if (localStorage.getItem('countrysSpare')) {
      this.countrys = JSON.parse(localStorage.getItem('countrysSpare'))
    } else {
      getCountrySpareList().then((res) => {
        this.countrys = res.data
        localStorage.setItem('countrysSpare', JSON.stringify(res.data))
      })
    }
    this.getShipyard()
  },

  mounted () {
  },

  methods: {
    // 获取造船厂选项
    getShipyard () {
      getShipyardApi().then(res => {
        this.shipyardOptions = res.data
      })
    }
  }
}
</script>

<style scoped lang="less">
.ShipNameEssentials{
  .right-side{
    box-sizing:border-box;
    padding:@gap;
  }

}
</style>
